import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsGmailComponent } from './simple-icons-gmail.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsGmailComponent ],
    exports:      [ SimpleIconsGmailComponent ],
    bootstrap:    []
})
export class SimpleIconsGmailModule {}
